
import { defineComponent, onMounted, onUnmounted, PropType, reactive } from 'vue'

// icons
import clockSVG from '@/assets/icons/clock.svg'

export default defineComponent({
    props: {
        delayedTime: {
            type: String,
            default: null,
        },
        dates: {
            type: Array as PropType<{ id: number; date: string; dateRef: { id: number; name: string; } }[]>,
            default: () => []
        },
        statusId: {
            type: Number,
            default: null
        },
    },
    components: { 'clock-svg': clockSVG },
    setup(props) {
        const state = reactive({
            isExpired: false,
            timerDisplayedTime: null as string | null,
            timerTime: null as number | null,
            intervalId: null as any | null,
        })

        const pad = (n: number) => String(n).padStart(2, '0')

        const formatDiffToHHMMSS = (from: Date, to: Date) => {
            const diffMs = to.getTime() - from.getTime()
            const isNegative = diffMs < 0

            const totalSeconds = Math.floor(Math.abs(diffMs) / 1000)

            const hours = Math.floor(totalSeconds / 3600)
            const minutes = Math.floor((totalSeconds % 3600) / 60)
            const seconds = totalSeconds % 60

            const time = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`

            return {
                time: isNegative ? `-${time}` : time,
                isExpired: isNegative,
                hours,
            }
        }

        const setTimeOnCompleted = () => {
            if (!props.dates.length) return

            const expectedDate = props.dates.find((d) => d.dateRef.name === 'Ориентировочный срок прибытия')

            if (expectedDate) {
                const completedDate = props.dates.find((d) => d.dateRef.name === 'Дата прибытия(факт)')

                if (completedDate) {
                    const completed = new Date(completedDate.date.replace(' ', 'T'))
                    const expected = new Date(expectedDate.date.replace(' ', 'T'))

                    const { time, isExpired } = formatDiffToHHMMSS(completed, expected)

                    state.timerDisplayedTime = time
                    state.isExpired = isExpired
                } else {
                    const now = new Date()
                    const expected = new Date(expectedDate.date.replace(' ', 'T'))

                    const { time, isExpired } = formatDiffToHHMMSS(now, expected)

                    state.timerDisplayedTime = time
                    state.isExpired = isExpired
                }
            }
        }

        const timerTick = () => {
            const expectedDate = props.dates.find((d) => d.dateRef.name === 'Ориентировочный срок прибытия')

            if (expectedDate) {
                const now = new Date()
                const expected = new Date(expectedDate.date.replace(' ', 'T'))

                const { time, isExpired } = formatDiffToHHMMSS(now, expected)

                state.timerDisplayedTime = time
                state.isExpired = isExpired
            }
        }

        onMounted(() => {
            if (props.delayedTime) {
                state.timerDisplayedTime = props.delayedTime
                state.isExpired = true
                return
            }

            if (props.statusId && props.statusId === 2) {
                setTimeOnCompleted()
                return
            }

            timerTick()
            state.intervalId = setInterval(() => {
                timerTick()
            }, 1000)
        })

        onUnmounted(() => {
            if (state.intervalId) {
                clearInterval(state.intervalId)
            }
        })

        return {
            state,
        }
    },
})
